var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 42,
    viewBox: "-2 -2 49 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.212 1.106 C 3.228 2.282, 0.009 7.118, 0.004 11.934 C -0.002 17.533, 3.457 22.937, 13.488 33 L 22.959 42.500 33.050 32.500 C 43.478 22.167, 45.989 18.738, 46.015 14.800 C 46.028 12.948, 46.220 12.792, 47 14 C 47.699 15.081, 47.941 14.243, 47.866 11 C 47.772 6.896, 47.696 6.764, 47 9.500 C 46.284 12.314, 46.229 12.344, 46.118 9.973 C 45.847 4.180, 39.118 -0.537, 32.812 0.647 C 30.990 0.989, 28.027 2.364, 26.226 3.703 L 22.953 6.138 19.900 3.569 C 18.220 2.156, 16.319 0.994, 15.673 0.986 C 15.028 0.979, 13.600 0.784, 12.500 0.554 C 11.400 0.324, 9.020 0.572, 7.212 1.106 M 0.272 12 C 0.272 14.475, 0.467 15.488, 0.706 14.250 C 0.944 13.012, 0.944 10.988, 0.706 9.750 C 0.467 8.512, 0.272 9.525, 0.272 12",
    stroke: "#f06292",
    strokeWidth: "4px",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoheart);
export default __webpack_public_path__ + "static/media/noheart.90da3016fca75df1fe3b3c74415e7301.svg";
export { ForwardRef as ReactComponent };